const langPack = [
    {
        "id": "3C4E7130-3BA8-4A53-9AC9-20AE470926AD",
        "module": "FlightSearch",
        "coponent": "SearchBox",
        "label": "swRoundTrip",
        "textEn": "Round Trip",
        "textEnM": "Rnd Trip",
        "textTh": "ไป-กลับ",
        "textThM": "ไป-กลับ"
    },
    {
        "id": "BC30446E-7DB6-4D6A-B253-1D4FCEF6E027",
        "module": "FlightSearch",
        "coponent": "SearchBox",
        "label": "swMultiCity",
        "textEn": "Multi-City",
        "textEnM": "Multi-City"
    },
    {
        "id": "6C96C20E-A919-4614-92EB-7B59FB1D51F5",
        "module": "FlightSearch",
        "coponent": "AirportSelector",
        "label": "acAirport",
        "textEn": "Airport, City",
        "textEnM": "Airport, City",
        "textTh": "สนามบิน, เมือง",
        "textThM": "สนามบิน, เมือง"
    },
    {
        "id": "014035A9-851B-48C7-8C15-10D25146D1CB",
        "module": "FlightSearch",
        "coponent": "AirlineSelector",
        "label": "acAirline",
        "textEn": "Airline",
        "textEnM": "Airline",
        "textTh": "สายการบิน",
        "textThM": "สายการบิน"
    },
    {
        "id": "2E11A2AF-6C36-4033-9E3F-38DB094B7CBF",
        "module": "FlightSearch",
        "coponent": "SearchBox",
        "label": "dpDeparture",
        "textEn": "Departure",
        "textEnM": "Departure",
        "textTh": "วันเดินทาง",
        "textThM": "วันเดินทาง"
    },
    {
        "id": "ECE32B09-2F42-44F5-BAF8-4BEE80F518D0",
        "module": "FlightSearch",
        "coponent": "SearchBox",
        "label": "dpReturn",
        "textEn": "Return",
        "textEnM": "Return",
        "textTh": "วันเดินทางกลับ",
        "textThM": "วันเดินทางกลับ"
    },
    {
        "id": "867AF8F1-2A58-423D-BE21-849088CE6B3B",
        "module": "FlightSearch",
        "coponent": "PassengerBox",
        "label": "lbPsngrAdt",
        "textEn": "Adults",
        "textEnM": "Adults",
        "textTh": "ผู้ใหญ่",
        "textThM": "ผู้ใหญ่"
    },
    {
        "id": "E0571B49-8596-48E6-BE02-9E3CDAF5722F",
        "module": "FlightSearch",
        "coponent": "PassengerBox",
        "label": "lbPsngrCnn",
        "textEn": "Children",
        "textEnM": "Children",
        "textTh": "เด็ก",
        "textThM": "เด็ก"
    },
    {
        "id": "A584F2DA-3DFD-4AFF-A8D5-A3C823F69E46",
        "module": "FlightSearch",
        "coponent": "PassengerBox",
        "label": "lbPsngrInf",
        "textEn": "Infants",
        "textEnM": "Infants",
        "textTh": "ทารก",
        "textThM": "ทารก"
    },
    {
        "id": "D6F428B8-88DC-4B80-85FD-C9D623DFCEC0",
        "module": "FlightSearch",
        "coponent": "PassengerBox",
        "label": "lbSelSeatClassEco",
        "textEn": "Economy",
        "textEnM": "Economy",
        "textTh": "ประหยัด",
        "textThM": "ประหยัด"
    },
    {
        "id": "9FCE56A0-F155-4164-AD8E-D6B0419316DB",
        "module": "FlightSearch",
        "coponent": "PassengerBox",
        "label": "lbSelSeatClassBus",
        "textEn": "Business",
        "textEnM": "Business",
        "textTh": "ธุรกิจ",
        "textThM": "ธุรกิจ"
    },
    {
        "id": "FC717486-15FE-4450-9CE1-E2C32F07813C",
        "module": "FlightSearch",
        "coponent": "PassengerBox",
        "label": "lbSelSeatClassFst",
        "textEn": "First",
        "textEnM": "First"
    },
    {
        "id": "C73C9040-9040-4AEE-ACA6-E6F63E99491F",
        "module": "FlightSearch",
        "coponent": "PassengerBox",
        "label": "lbMenuText",
        "textEn": "Passenger",
        "textEnM": "Passenger",
        "textTh": "ผู้โดยสาร",
        "textThM": "ผู้โดยสาร"
    },
    {
        "id": "AFF3B122-4A3A-4638-8889-F8955AF79554",
        "module": "FlightSearch",
        "coponent": "SearchBox",
        "label": "btSearch",
        "textEn": "Search",
        "textEnM": "Search",
        "textTh": "ค้นหา",
        "textThM": "ค้นหา"
    }
]

export default langPack;